(ns common.schema.entities.rotation-period.options)

(def rotation-type-options
  [{:key :rotation.type/ad-hoc
    :label "Ad hoc"}
   {:key :rotation.type/daily
    :label "Daily"}
   {:key :rotation.type/weekly
    :label "Weekly"}
   {:key :rotation.type/monthly
    :label "Monthly"}
   {:key :rotation.type/quarterly
    :label "Quarterly"}
   {:key :rotation.type/yearly
    :label "Yearly"}
   {:key :rotation.type/custom
    :label "Custom"}])

(def rotation-period-status-options
  [{:key :rotation-period.status/draft
    :label "Draft"}
   {:key :rotation-period.status/active
    :label "Active"}
   {:key :rotation-period.status/archived
    :label "Archived"}])

(defn archived?
  "An archived rotation period cannot be selected for a new cycle."
  [rotation-period]
  (= :rotation-period.status/archived
     (:rotation-period/rotation-period-status rotation-period)))
